import React, { useCallback, useEffect, useState } from 'react';
import api from '../../api/axios';

function HubSpotMeetingControls({ campaignId, config, onChange }) {
  const [status, setStatus] = useState(null);
  const [links, setLinks] = useState([]);
  const [selected, setSelected] = useState(config.eventTypeId || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const statusResponse = await api.get('/integrations/hubspot-meetings/status');
      setStatus(statusResponse.data);
      if (statusResponse.data.connected) {
        const linksResponse = await api.get('/integrations/hubspot-meetings/meeting-links');
        setLinks(linksResponse.data.meetingLinks || []);
      }
      setError('');
    } catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { setSelected(config.eventTypeId || ''); }, [config.eventTypeId]);

  const connect = async () => {
    setBusy(true); setError('');
    try {
      const response = await api.post('/integrations/hubspot-meetings/start', { returnPath: `/campaigns/${campaignId}/agent` });
      window.location.assign(response.data.url);
    } catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); setBusy(false); }
  };

  const useLink = async () => {
    if (!selected) return;
    setBusy(true); setError('');
    try {
      const response = await api.patch(`/integrations/hubspot-meetings/campaigns/${campaignId}/meeting-link`, { meetingLinkId: selected });
      onChange({ ...config, ...response.data.config });
    } catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); }
    finally { setBusy(false); }
  };

  return <div className="meeting-provider-native-panel">
    <div className="meeting-provider-native-head">
      <div><strong>HubSpot Meetings</strong><p>Koppel HubSpot één keer en kies daarna per campagne de juiste meeting scheduling page.</p></div>
      {!status?.connected
        ? <button className="campaign-agent-button secondary" disabled={busy} onClick={connect}>{busy ? 'Doorsturen…' : 'HubSpot koppelen'}</button>
        : <span className="calendly-connected-badge">HubSpot gekoppeld</span>}
    </div>
    {error && <div className="planner-warning">{error}</div>}
    {status?.connected && <div className="meeting-provider-native-grid">
      <label>Meeting link<select value={selected} onChange={(e) => setSelected(e.target.value)}><option value="">Kies meeting link</option>{links.map((item) => <option key={item.id} value={item.id}>{item.name}{item.type ? ` · ${item.type}` : ''}</option>)}</select></label>
      <div className="meeting-provider-native-actions"><button className="campaign-agent-button secondary" disabled={busy || !selected} onClick={useLink}>Gebruik voor campagne</button></div>
    </div>}
    {status?.connected && <p className="planner-help">De meetinglink wordt automatisch beheerd. Voor booking-events kan de campagnewebhook worden gevoed vanuit HubSpot Workflows, een HubSpot app webhook, Make, Zapier of n8n totdat de volledige CRM-associatiesync wordt geactiveerd.</p>}
  </div>;
}

export default HubSpotMeetingControls;
